import React, { useState } from 'react';
import { Card, Form, Button, Row, Col } from 'react-bootstrap';
import { useAuth } from '../utils/AuthContext';
import Header from '../layouts/Header';
import Footer from '../layouts/Footer';
import { toast } from 'react-toastify';
import { getFunctions, httpsCallable } from 'firebase/functions';

export default function ContactUs() {
    const { currentUser } = useAuth();
    const [formData, setFormData] = useState({
        name: currentUser?.displayName || '',
        email: currentUser?.email || '',
        subject: '',
        type: 'bug',
        message: ''
    });
    const [loading, setLoading] = useState(false);

    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);

        try {
            const functions = getFunctions();
            const sendContactEmail = httpsCallable(functions, 'BugOrFeature');
            
            await sendContactEmail({
                ...formData,
                userId: currentUser?.uid
            });

            toast.success('Message sent successfully!');
            setFormData(prev => ({
                ...prev,
                subject: '',
                message: ''
            }));
        } catch (error) {
            console.error('Error sending message:', error);
            toast.error('Failed to send message. Please try again.');
        } finally {
            setLoading(false);
        }
    };

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData(prev => ({
            ...prev,
            [name]: value
        }));
    };

    return (
        <React.Fragment>
            <Header />
            <div className="main main-app p-3 p-lg-4">
                <div className="d-flex align-items-center justify-content-between mb-4">
                    <h4 className="main-title mb-0">Contact Us</h4>
                </div>

                <Row className="justify-content-center">
                    <Col md={8} lg={6}>
                        <Card className="card-one">
                            <Card.Header>
                                <Card.Title as="h6">Get in Touch</Card.Title>
                                <Card.Text>
                                    We'd love to hear from you. Send us a message and we'll respond as soon as possible.
                                </Card.Text>
                            </Card.Header>
                            <Card.Body>
                                <Form onSubmit={handleSubmit}>
                                    <Row>
                                        <Col md={6}>
                                            <Form.Group className="mb-3">
                                                <Form.Label>Name</Form.Label>
                                                <Form.Control
                                                    type="text"
                                                    name="name"
                                                    value={formData.name}
                                                    onChange={handleChange}
                                                    required
                                                    disabled={loading}
                                                />
                                            </Form.Group>
                                        </Col>
                                        <Col md={6}>
                                            <Form.Group className="mb-3">
                                                <Form.Label>Email</Form.Label>
                                                <Form.Control
                                                    type="email"
                                                    name="email"
                                                    value={formData.email}
                                                    onChange={handleChange}
                                                    required
                                                    disabled={loading}
                                                />
                                            </Form.Group>
                                        </Col>
                                    </Row>

                                    <Row>
                                        <Col md={6}>
                                            <Form.Group className="mb-3">
                                                <Form.Label>Type</Form.Label>
                                                <Form.Select
                                                    name="type"
                                                    value={formData.type}
                                                    onChange={handleChange}
                                                    disabled={loading}
                                                >
                                                    <option value="bug">Bug Report</option>
                                                    <option value="feature">Feature Request</option>
                                                    <option value="support">Support</option>
                                                    <option value="other">Other</option>
                                                </Form.Select>
                                            </Form.Group>
                                        </Col>
                                        <Col md={6}>
                                            <Form.Group className="mb-3">
                                                <Form.Label>Subject</Form.Label>
                                                <Form.Control
                                                    type="text"
                                                    name="subject"
                                                    value={formData.subject}
                                                    onChange={handleChange}
                                                    required
                                                    disabled={loading}
                                                />
                                            </Form.Group>
                                        </Col>
                                    </Row>

                                    <Form.Group className="mb-4">
                                        <Form.Label>Message</Form.Label>
                                        <Form.Control
                                            as="textarea"
                                            rows={5}
                                            name="message"
                                            value={formData.message}
                                            onChange={handleChange}
                                            required
                                            disabled={loading}
                                            placeholder="Please describe your issue or request in detail..."
                                        />
                                    </Form.Group>

                                    <div className="d-grid gap-2 d-md-flex justify-content-md-end">
                                        <Button 
                                            type="submit" 
                                            disabled={loading}
                                            size="lg"
                                        >
                                            {loading ? 'Sending...' : 'Send Message'}
                                        </Button>
                                    </div>
                                </Form>
                            </Card.Body>
                        </Card>
                    </Col>
                </Row>

                <Footer />
            </div>
        </React.Fragment>
    );
} 